define('modules/media/audio',['require','exports','module','modules/media/binder','app','modules/media/modal','htmlparser'],function(require, exports, module) {"use strict";

	var Binder = require("modules/media/binder");
	var app = require("app");

	var Modal = require("modules/media/modal");

	//var dotdot = require("dotdotdot");

	var Htmlparser = require("htmlparser");

	return module.exports = {

		id : {},
		type : "audio",
		box : {},
		btn : {},
		btnclose : {},
		player : {},

		moveText : function(Context, MaxCh, elP, i, nav) {

			/*if (elP.data('dotdotdot')) {
				var fx = this;

				elP.trigger("destroy.dot");
				(elP).parent().append(nav);
				(elP).parent().find('.pag_txt').on("click", function(o) {

					(elP).parent().find('.pag_txt').removeClass('sel');
					o.currentTarget.className += ' sel';
					fx(Context, MaxCh, elP, Number(o.currentTarget.innerHTML), nav);

				}
				
				);

			}*/



			var to = MaxCh * i;

			//	//console.log('ended-->', elP.data('ended')  , to);

			var nuovo = Context.substring(to, (MaxCh * (i + 1)));

			nuovo = nuovo.substr(nuovo.indexOf(' ') + 1);
			var ended = nuovo.lastIndexOf(' ');

			// nuovo= nuovo.substr(nuovo.lastIndexOf(' '));
			nuovo = nuovo.substr(0, ended);
			nuovo = HTMLtoXML(nuovo);

			elP.data('ended', ended);

			elP.html(nuovo);

			//elP.dotdotdot();

		},

		dotText : function(elements) {
			//var CallBk = _.bind(this.moveText, this.moveText);
			//  var redo= _.bind(this.dotText, this.dotText);
			var el = $(elements);
			var cnt = el.find('.view-box-speak');
			var img = el.find('.view-box-image');
			var elP = cnt.find('p');
			var elSpan = cnt.find('p span');
			//var Context = this.Context = elP.html();
			
			//var redo = _.bind(this.dotText, this);

		
			elSpan.remove('br.extraline');

			return (function() {
				
				
				
				var ref=elements.querySelectorAll('.view-box-speak')[0].scrollHeight;//$(elements).find('.view-box-speak').prop('scrollHeight') ;

				//console.log('***> textfill', ref, cnt.height());
				
				
				
				if (ref > cnt.height()) {

					
					if ( img.height()>0){
					cnt.height(img.height());
					
					
					
					
						
					}
					

					var tot = ref + cnt.height();

					//var p = elP.outerHeight(true);

					var p = elSpan.outerHeight(true);

					var nop = ref - p;

					var visp = cnt.height() - nop;

					var LineH = parseInt(elSpan.css('line-height'), 10);

					var totline = Math.floor(p / LineH);
					var visline = Math.floor(visp / LineH) ;
					var stepline = Math.ceil(totline / visline);
					
					if ((totline%visline)>0){
						
						var diffline= visline-(totline%visline);
					//	var nl='';
						
						for (var k = 0; k <diffline; k++) {
							
							elSpan.append ($('<br/>',{'class':'extraline'}));
							
						}
						
						//elSpan.append($(nl));

						
					}
					
					
					
					
					var counterline = 0;

					//console.log('***> ',visline, LineH, totline  , totline%visline);

					if ((visline * LineH >0)){
					
					elSpan.css({
						display : 'block',
						height : visline * LineH + 'px',
						overflow : 'hidden'
					});}
					
					
					
					
					//return

					var nav = '';

					if (elSpan.parent().find('.pag_txt').length === 0) {
						
						
						////console.log("CREO" ,elSpan.parent().find('.pag_txt').length )

						for (var j = 0; j < stepline; j++) {

							var sel = j === 0 ? 'sel' : '';

							nav += '<a style="left:'+j*30  +'px" class="pag_txt ' + sel + '" id="pag_' + j + '">' + (j + 1) + '</a>';

						};

						elSpan.parent().append(nav);

						elSpan.parent().find('.pag_txt').on("click", function(e) {
							
							
						var nextLine=	visline * (Number(e.currentTarget.innerHTML) -1);
						
							//console.log('next line***> ',nextLine );
						
						if( totline-nextLine < visline){
							
							//console.log('minor***> ',visline-(totline-nextLine));
							
							nextLine +=visline-(totline-nextLine);
							
						}
						
						

							
						
							

							var to =   nextLine * LineH   ;

							
							counterline=to;
							
							
							
							elSpan.scrollTop(to);
							
							
							

							elSpan.parent().find('.pag_txt').removeClass('sel');
							e.currentTarget.className += ' sel';

						});
					}

					/*
					elP.css({
					height : visp - 50 + 'px',
					'min-height':'100px'
					});

					elP.dotdotdot({
					callback : function(isTruncated, orgContent) {

					if (isTruncated) {

					var to = (elP).html().lastIndexOf('...')+1;

					var pager = Math.ceil(Context.toString().length / to);

					var nav = '';

					for (var j = 0; j < pager; j++) {

					var sel= j===0?'sel':'';

					nav += '<a class="pag_txt '+ sel+'" id="pag_' + j + '">' + j + '</a>';

					};

					CallBk(Context, to, elP, 0, nav);

					}

					}
					});*/

					//	_

				}
			}
			)();
			////console.log(elements.querySelectorAll('.view-box-speak')[0].scrollHeight);

		},

		load : function(modules_cfg, type, el, media, elements) {

			if (!el.getAttribute('is_loaded') && _.isEmpty(this.player)) {

				//TODO controllo supporto audio nativo  ed eventuale integrazione  (mediaelements/audiojs)
				//this.add_player (el);

				this.player = media.audio;

				if (app.current_device != 'mobile') {

					this.dotText(elements);

				}

				var sources = this.player.querySelectorAll('source');
				var l = sources.length;
				var j = 0;

				//this.player.load();

				/*	var myTypes = new Array("audio/mp4", "audio/ogg", "audio/webm");

				for (var i = 0, len = myTypes.length; i < len; x++) {
				var canPlay = this.player.canPlayType(myTypes[i]);
				if ((canPlay == "maybe") || (canPlay == "probably"))
				playAny = 1;
				}*/

				////////console.log (sources, media);

				//this.player.setSrc(media);

				this.id = elements.id;

				this.box = elements.querySelectorAll('.sound-ico-control')[0];
				this.btn = document.getElementById(this.id + "_btn");
				this.btnclose = document.getElementById(this.id + "_btnclose");

				this.Bind(modules_cfg, el, elements.id);

			} else {

				try {

					if (app.current_device != 'mobile') {
						////console.log($(elements).find('.pag_txt'));

						$(elements).find('.pag_txt').off("click");
						$(elements).find('.pag_txt').remove();

						$(elements).find('.view-box-speak p span').removeAttr('style');
						$(elements).find('.view-box-speak').removeAttr('style');

						this.dotText(elements);

					}

				} catch(ex) {

				}

				//////console.log ('audio già assegnato');
			}
		},

		add_player : function(el) {

			////////console.log (id);

			this.player = new MediaElementPlayer('#' + el.id, {
				// if the <audio width> is not specified, this is the default
				//defaultAudioWidth : 480,
				// if the <audio height> is not specified, this is the default
				//defaultAudioHeight : 270,
				// if set, overrides <audio width>
				//audioWidth : -1,
				// if set, overrides <audio height>
				//audioHeight : -1,
				// width of audio player
				audioWidth : 400,
				// height of audio player
				audioHeight : 30,
				// initial volume when the player starts
				startVolume : 0.8,
				// useful for <audio> player loops
				loop : false,
				// enables Flash and Silverlight to resize to content size
				enableAutosize : true,
				// the order of controls you want on the control bar (and other plugins below)
				features : ['playpause', 'progress', 'current', 'duration', 'tracks', 'volume', 'fullscreen'],
				// Hide controls when playing and mouse is not over the audio
				alwaysShowControls : false,
				// force iPad's native controls
				iPadUseNativeControls : false,
				// force iPhone's native controls
				iPhoneUseNativeControls : true,
				// force Android's native controls
				AndroidUseNativeControls : true,
				// forces the hour marker (##:00:00)
				alwaysShowHours : false,
				// show framecount in timecode (##:00:00:00)
				//showTimecodeFrameCount : false,
				// used when showTimecodeFrameCount is set to true
				//framesPerSecond : 25,
				// turns keyboard support on and off for this instance
				enableKeyboard : false,
				// when this player starts, it will pause other players
				pauseOtherPlayers : true,
				// array of keyboard commands
				keyActions : [],

				success : function(mediaElement, domObject) {

				},
				error : function() {
					//alert('Error setting media!');
				}
			});

			//	//////console.log (mediaElement);

			// ... more code ...
			this.player.pause();
			//player.setSrc('mynewfile.mp4');

		},

		player_Toggle : function(event) {

			return (function(el) {

				var AudioBox = el;
				var parent = el.parentElement;
				var player = parent.getElementsByTagName("audio")[0];

				if (!player.paused) {

					if (player.networkState === 2 || player.networkState === 1) {
						try {
							AudioBox.className = "ico-audio-play sound-ico-control";
							return player.pause();
						} catch (err) {

						}
					}
				} else {
					AudioBox.className = "ico-audio-pause sound-ico-control";
					return player.play();
				}

			})(event.currentTarget);

		},

		showModale : function(event) {

			return (function(el) {

				var parent = el.parentElement;

				var PairBox = parent.parentElement;
				var SpeakBox = parent;
				var ImgBox = PairBox.querySelectorAll('div')[0];

				PairBox.className += " viewPopup";

				/*var IntervistaBox = el.parentElement;
				 var IntervistaTitolo = IntervistaBox.querySelectorAll('h1')[0];
				 var IntervistaContenuto = IntervistaBox.querySelectorAll('p')[0];
				 var IntervistaChiudi = '<a class="btnReader btnCloseModale" onclick="Modal.close();">Chiudi</a>';

				 var Slide = el.parentElement.parentElement.parentElement.parentElement.parentElement;
				 //var contentModale = document.getElementById("");

				 Modal.open({
				 content : IntervistaChiudi + IntervistaTitolo.outerHTML + IntervistaContenuto.outerHTML + IntervistaChiudi,
				 draggable : false,
				 width : '98%',
				 height : '98%',
				 openCallback : function() {
				 Slide.className += "noSwiping";
				 },
				 closeCallback : function() {

				 Slide.className = Slide.className.replace("noSwiping", "");

				 }
				 });*/

			})(event.currentTarget);

		},

		hideModale : function(event) {

			return (function(el) {

				var parent = el.parentElement;

				var PairBox = parent.parentElement;
				var SpeakBox = parent;
				var ImgBox = PairBox.querySelectorAll('div')[0];

				PairBox.className = PairBox.className.replace("viewPopup", "");

			})(event.currentTarget);

		},

		hideModaleInUscita : function(id) {

			var PairBox = document.getElementById(id + "_pairblock");
			PairBox.className = PairBox.className.replace("viewPopup", "");

		},

		Bind : function(modules_cfg, el, id) {

			//player.addEventListener('webkitendfullscreen', onMediaEndsFullScreen, false);
			//  mythis.addEventListener("webkitbeginfullscreen", enteringFullscreen, false);
			// mythis.addEventListener("webkitendfullscreen", exitingFullscreen, false);
			/*
			 $('Media#my-Media').bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
			 var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
			 var event = state ? 'FullscreenOn' : 'FullscreenOff';

			 // Now do something interesting
			 alert('Event: ' + event);

			 });

			 ar fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
			 var fullscreenEnabled = document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled;
			 * */

			Binder.addEvent(this.box, 'click', this.player_Toggle);

			//if (app.current_device === 'mobile') {
			Binder.addEvent(this.btn, 'click', this.showModale);
			Binder.addEvent(this.btnclose, 'click', this.hideModale);

			//.find('.pag_txt').on("click"

			//}

			/*this.player.onended = (function(x) {
			 return function(e) {
			 //////console.log (x, e);
			 };
			 })(this.poster);*/

		},

		Unbind : function(id) {
			
			//console.log('tolgo' ,this.player ,_.isUndefined(this.player) , _.isNull(this.player),_.isEmpty(this.player) );

			if (_.isUndefined(this.player) || _.isNull(this.player) ) {
				
				//console.log('no play ')
				return;
			}

			if (!this.player.paused) {

				if ('onLeave' in modules_cfg[id].properties.events) {

					if (modules_cfg[id].properties.events['onLeave'] === 'stop') {

						if (this.player.networkState === 2 || this.player.networkState === 1) {

							try {
								this.box.className = "ico-audio-play sound-ico-control";
								this.player.currentTime = 0;

								//myVid.addEventListener("canplay",function() { myVid.currentTime = 5;});
								//http://stackoverflow.com/questions/20240088/issue-setting-currenttime-in-html5-Media
								this.player.pause();

							} catch (err) {

							}

						}

					}

				}

			}

			$('#' + id).find('.pag_txt').off("click").remove();
			$('#' + id).find('.view-box-speak p span').scrollTop(0);;
			$('#' + id).find('.view-box-speak p span').removeAttr('style');
			$('#' + id).find('.view-box-speak').removeAttr('style');
			// this.Context

			//	//////console.log ( 'ERASE ' ,this.player    , this )

			//this.player.setCurrentTime(0);
			Binder.removeEvent(this.box, 'click', this.player_Toggle);

			//if (app.current_device === 'mobile') {
			Binder.removeEvent(this.btn, 'click', this.showModale);
			Binder.removeEvent(this.btnclose, 'click', this.hideModale);
			this.hideModaleInUscita(id);
			//}

			////////console.log (this.player);
			this.Context = {};
			this.ContextH = 0;
			this.player = {};
			this.poster = {};
			//this.btn = {};
			this.id = {};

		}
	};

});

